"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'conversations.error.failedToLoad': 'Failed to load conversations',
    'conversations.error.failedToDelete': 'Failed to delete conversation',
    'conversations.error.failedToToggleFavorite': 'Failed to toggle favorite status',
};
